import { render } from "./GlobalErrorModal.vue?vue&type=template&id=134bfad7"
import script from "./GlobalErrorModal.vue?vue&type=script&lang=js"
export * from "./GlobalErrorModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/GlobalErrorModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "134bfad7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('134bfad7', __exports__)) {
    api.reload('134bfad7', __exports__)
  }
  
  module.hot.accept("./GlobalErrorModal.vue?vue&type=template&id=134bfad7", () => {
    api.rerender('134bfad7', render)
  })

}


export default __exports__